"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StateHistory = /** @class */ (function () {
    /**
     * create a new StateHistory
     * @param maxLength maximum number of entries that should be stored (default=50)
     */
    function StateHistory(maxLength) {
        if (maxLength === void 0) { maxLength = 50; }
        this.past = [];
        this.present = null;
        this.future = [];
        this.subscribers = [];
        this.maxLength = maxLength;
    }
    Object.defineProperty(StateHistory.prototype, "numPrev", {
        get: function () {
            return this.past.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateHistory.prototype, "numNext", {
        get: function () {
            return this.future.length;
        },
        enumerable: true,
        configurable: true
    });
    StateHistory.prototype.push = function (state) {
        if (this.present)
            this.past.push(this.present);
        this.present = state;
        if (this.future.length)
            this.future = [];
        if (this.past.length > this.maxLength) {
            this.past.splice(0, this.past.length - this.maxLength);
        }
        this.emit(this.present);
        return this.present;
    };
    StateHistory.prototype.goPrev = function () {
        // could do go(-1) but this is faster
        var newPresent = this.past.pop();
        this.future.splice(0, 0, this.present);
        this.present = newPresent;
        this.emit(this.present);
        return this.present;
    };
    StateHistory.prototype.goNext = function () {
        var newPresent = this.future.shift();
        this.past.push(this.present);
        this.present = newPresent;
        this.emit(this.present);
        return this.present;
    };
    StateHistory.prototype.goLast = function () {
        var _a;
        var newPresent = this.future.pop();
        (_a = this.past).push.apply(_a, this.future);
        this.present = newPresent;
        this.emit(this.present);
        return this.present;
    };
    StateHistory.prototype.go = function (i) {
        if (i === 0) {
            return this.present;
        }
        if (i > 0) {
            var newPresent = this.future.splice(i - 1, 1)[0];
            this.past = this.past.concat([this.present], this.future.splice(0, i - 1));
            this.present = newPresent;
            this.emit(this.present);
            return this.present;
        }
        else {
            var start = this.past.length + i;
            var newPresent = this.past.splice(start, 1)[0];
            this.future = this.past.splice(start, this.past.length - start).concat([
                this.present
            ], this.future);
            this.present = newPresent;
            this.emit(this.present);
            return this.present;
        }
    };
    StateHistory.prototype.get = function (i) {
        if (i === 0) {
            return this.present;
        }
        if (i > 0) {
            return this.future[i - 1];
        }
        else {
            return this.past[this.past.length + i];
        }
    };
    StateHistory.prototype.subscribe = function (callback) {
        this.subscribers.push(callback);
    };
    StateHistory.prototype.unsubscribe = function (callback) {
        var index = this.subscribers.indexOf(callback);
        if (~index) {
            this.subscribers.splice(index, 1);
        }
    };
    StateHistory.prototype.unsubscribeAll = function () {
        this.subscribers.length = 0;
    };
    StateHistory.prototype.emit = function (state) {
        this.subscribers.forEach(function (callback) { return callback(state); });
    };
    return StateHistory;
}());
exports.StateHistory = StateHistory;



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/~/state-history/dist/index.js
 ** module id = 9
 ** module chunks = 0
 **/